import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { colors, fonts } from "../../../styles/variables";

export type AddButtonVariant = "standard" | "inverted" | "disabled";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }

  ${breakpoints.smDown} {
    margin-right: 16px;
  }
`;

export const RewardCard = styled.div`
  width: 160px;
  height: 249px;
  display: flex;
  flex-direction: column;
  background: ${colors.merchCardDefaultBackgroundColor};
  position: relative;

  ${breakpoints.smDown} {
    width: 160px;
    height: 249px;
  }
`;

export const RewardCardImgWrapper = styled(Link)`
  width: 100%;
  height: auto;
  cursor: pointer;
`;

export const RewardCardImg = styled.img`
  position: absolute;
  height: calc(100% - 30px);
  width: 100%;
  object-fit: contain;
  padding: 16px;
`;

export const RewardCardFooter = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  height: 30px;
  bottom: 0;
  background: ${colors.black};
  color: ${colors.white};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const AddButtonWrapper = styled.div`
  margin-right: 0px;
`;

export const AddButton = styled.button<{ variant: AddButtonVariant }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  width: 100%;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
  font-family: ${fonts.fontBauMedium};
  background-color: ${colors.black};
  color: ${colors.white};
  border: 1px solid ${colors.black};

  ${(props) =>
    props.variant === "disabled" &&
    css`
      border: 1px solid ${colors.gray};
      color: ${colors.white};
      background-color: ${colors.gray};
      cursor: not-allowed;
    `};
`;

export const ButtonText = styled.div``;

export const Points = styled.div`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 18px;
  line-height: 20px;
  color: ${colors.white};
`;

export const ButtonTextWrapper = styled.div`
  display: flex;
  color: ${colors.white};
  flex-direction: row;
  position: relative;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
